import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const WorkTypesEdit = (props) => (
  <Edit {...props} resource="workingTypes">
    <Form />
  </Edit>
);

WorkTypesEdit.propTypes = {};

export default WorkTypesEdit;
